import { MutationTree } from 'vuex';
import Vue from 'vue';

const mutations: MutationTree<Store.Player.State> = {
  setPlayerConfig(state, payload: Store.Player.PlayerConfig) {
    Vue.set(state, 'config', payload);
  },
};

export default mutations;
